/**
 * LandingARKflowLandingRoute
 *
 * Page component for LandingARKflowLandingRoute
 * Path: /ar
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { LandingARKflowLandingPageView as __LandingARKflowLandingPageView } from '@/components/traits/LandingARKflowLandingPageView';
import { LandingARKflowLandingAnalyticsView as __LandingARKflowLandingAnalyticsView } from '@/components/traits/LandingARKflowLandingAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { SharedEntityStoreContext, useSharedEntityStore, usePageHead } from '@almadar/ui/hooks';
import { ModalSlot } from '@almadar/ui/components';

interface LandingARKflowLandingRouteProps {
  // Add any page-level props here
}

export function LandingARKflowLandingRoute(_props: LandingARKflowLandingRouteProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","kflow-landing:meta.title"],"description":["i18n/t","kflow-landing:meta.description"],"access":"public","indexing":"index","origin":"https://kflow.academy","siteName":"KFlow","alternates":[{"locale":"en","path":"/"},{"locale":"ar","path":"/ar"},{"locale":"sl","path":"/sl"}],"defaultLocale":"en", path: __location.pathname });

  const _sharedStore = useSharedEntityStore();

  return (
    <SharedEntityStoreContext.Provider value={_sharedStore}>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__LandingARKflowLandingPageView config={{ initPayload: __navState }} />
          <__LandingARKflowLandingAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </SharedEntityStoreContext.Provider>
  );
}

export default LandingARKflowLandingRoute;
